import React, { useState } from "react";
import GradeModal from "./modals/GradeModal";
import "./Tables.css";

const StudentRow = ({ student, grades, labs }) => {
  const [selectedGrade, setSelectedGrade] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const getFinalGradeForLab = (labId) =>
  {
    if (!grades) {
      return null
    } else {
      return grades.find((g) => g.lab_id === labId);
    }
    
  }
    

  const handleGradeClick = (grade) => {
    setSelectedGrade(grade);
    setShowModal(true);
  };

  return (
    <>
      <tr>
        <td className="table-td student-cell">
          <div className="student-name">{student.full_name}</div>

          <div className="student-contacts">
            {student.git && (
              <div className="contact-row">
                <img src="/gitlab.svg" alt="gitlab" width={14} height={14} />
                <span>{student.git}</span>
              </div>
            )}
            {student.phone_number && (
              <div className="contact-row">
                <img src="/phone.svg" alt="phone" width={14} height={14} />
                <span>{student.phone_number}</span>
              </div>
            )}
            {student.email && (
              <div className="contact-row">
                <img src="/email.svg" alt="email" width={14} height={14} />
                <span>{student.email}</span>
              </div>
            )}
            {student.telegram && (
              <div className="contact-row">
                <img src="/telegram.svg" alt="telegram" width={14} height={14} />
                <span>{student.telegram}</span>
              </div>
            )}
          </div>
        </td>

        {labs && labs.map((lab) => {
          const finalGrade = getFinalGradeForLab(lab.id);

          return (
            <td
              key={lab.id}
              className={`grade-cell ${finalGrade ? "grade-cell-final" : ""}`}
              onClick={() => {
                if (finalGrade) handleGradeClick(finalGrade);
              }}
            >
              {finalGrade?.grade || "-"}
            </td>
          );
        })}
      </tr>

      {selectedGrade && (
        <GradeModal
          show={showModal}
          onClose={() => setShowModal(false)}
          grade={selectedGrade}
          lab={labs.find((l) => l.id === selectedGrade.lab_id)}
        />
      )}
    </>
  );
};

export default StudentRow;
